import React, { Component } from 'react';
import {observer} from 'mobx-react';
import styles from '../index.css';
import localStyles from './index.css';
import FontAwesome from 'react-fontawesome';
import {Bubbles} from '../SubComponents/index';
import {receptionBunkersStore, transportStore} from '../../../stores/index'
import ReceptionBunker from "./ReceptionBunker";
import TransportField from "./TransportField";
import fonts from "../../../../iconfonts.css";


@observer
export default class InputFlow extends Component {

    state = {active:false};

    shouldComponentUpdate(nextProps,nextState) {
        return nextState !== this.state;
    }

    activeToggle() {
        this.state.active
            ? this.setState({active:false})
            : this.setState({active:true})
    }

    render() {
        const bunker = receptionBunkersStore.receptionBunker;

        return (
            <div className={styles.innerContainer + ' ' + styles.inputFlow + (this.state.active ? ' ' + styles.activeTab : '')}>
                <div className={styles.content}>
                    <div className={styles.queueContainer}>
                        <div className={styles.stateToggleButton} onClick={this.activeToggle.bind(this)}>
                            {(this.state.active ? <FontAwesome name='compress' /> : <FontAwesome name='expand' />)}
                        </div>
                        <div className={styles.indicator} style={{right:0}}>
                            <div className={localStyles.cultureCircle + ' ' + localStyles.wheat + (this.state.selectedCrop === 0 ? ' ' + localStyles.selected : '')} onClick={()=>{this.setCrop(0)}}>
                                {transportStore.getTotalWheat}
                            </div>
                            <div className={localStyles.cultureCircle + ' ' + localStyles.rape + (this.state.selectedCrop === 1 ? ' ' + localStyles.selected : '')} onClick={()=>{this.setCrop(1)}}>
                                {transportStore.getTotalRape}
                            </div>
                            <div className={localStyles.cultureCircle + ' ' + localStyles.soy + (this.state.selectedCrop === 2 ? ' ' + localStyles.selected : '')} onClick={()=>{this.setCrop(2)}}>
                                {transportStore.getTotalSoy}
                            </div>
                            <div className={localStyles.cultureCircle + ' ' + localStyles.sunflower + (this.state.selectedCrop === 3 ? ' ' + localStyles.selected : '')} onClick={()=>{this.setCrop(3)}}>
                                {transportStore.getTotalSunflower}
                            </div>
                            <div className={localStyles.cultureCircle + ' ' + localStyles.corn + (this.state.selectedCrop === 4 ? ' ' + localStyles.selected : '')} onClick={()=>{this.setCrop(4)}}>
                                {transportStore.getTotalCorn}
                            </div>
                        </div>
                        <div className={localStyles.bunkerContainer}>
                            {bunker.map((item,i)=>{
                                return <ReceptionBunker item={item} i={i} key={i}/>
                            })}
                        </div>
                        <TransportField />
                        <div className={styles.queueBubbles}>
                            <Bubbles culture={receptionBunkersStore.getLineColor}/>
                        </div>
                        <div className={localStyles.inputLine + ' ' + localStyles[receptionBunkersStore.getLineColor]} />
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/shared/components/Game/InputFlow/index.js